/** @jsx jsx **/
import { jsx, Box, Flex, Text } from 'theme-ui'
import { Close } from '~/components/icons/close'
import FilterSecondary from '~/components/filter/filter-secondary'
import useMediaQuery from '~/hooks/use-media-query'

const FilterSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path
      d="M0.3125 2.34375H9.6875V3.28125H0.3125V2.34375ZM1.875 4.53125H8.125V5.46875H1.875V4.53125ZM3.75 6.71875H6.25V7.65625H3.75V6.71875Z"
      fill="white"
    />
  </svg>
)

interface IFilterHeader {
  handleShowFilter: () => void
  handleResetFilters: () => void
  showFilter: boolean
  itemsCount?: number
}

const FilterHeader = ({
  handleShowFilter,
  handleResetFilters,
  itemsCount,
  showFilter,
}: IFilterHeader) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: breakpoints => `(min-device-width: ${breakpoints[2]})`,
  })

  return (
    <Flex
      as="header"
      sx={{
        display: ['flex', null, null, 'none'],
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: '8px',
        // ml: [showFilter ? '24px' : 'auto', null, null, 'auto'],
        flexWrap: 'wrap',
        width: [showFilter ? '100vw' : '100%', null, null, 'unset'],
        backgroundColor: 'white',
        pb: '4px',
      }}
    >
      <Box
        sx={{
          width: ['100%', null, null, 'unset'],
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          gap: '12px',
          flex: 1,
        }}
      >
        <button
          sx={{
            variant: 'buttons.noStyle',
            display: 'flex',
            padding: '12px',
            alignItems: 'center',
            gap: '12px',
            backgroundColor: '#01182B',
            color: '#fff',
            fontWeight: 400,
            fontSize: '13px',
            lineHeight: '19.9px',
            letterSpacing: '0.5px',
            textTransform: 'capitalize',
          }}
          onClick={handleShowFilter}
        >
          <FilterSvg />
          <span>Filters</span>
        </button>
        <button
          sx={{
            variant: 'buttons.noStyle',
            display: 'flex',
            padding: '12px',
            alignItems: 'center',
            gap: '12px',
            backgroundColor: 'transparent',
            border: '1px solid #F3F3F3',
            background: 'white',
            color: '#041826',
            fontWeight: 400,
            fontSize: '13px',
            lineHeight: '19.9px',
            letterSpacing: '0.5px',
            textTransform: 'capitalize',
          }}
          onClick={handleResetFilters}
        >
          <span>Reset all</span>
        </button>
      </Box>
      {itemsCount ? (
        <Text
          sx={{
            minWidth: '100px',
            color: '#808080',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.5px',
          }}
        >
          {itemsCount} items
        </Text>
      ) : null}
      {/* {isDesktopOrLaptop && (
        <Flex
          sx={{
            alignItems: 'center',
          }}
        >
          <FilterSecondary
            handleStockOnly={handleStockOnly}
            isStockOnly={isStockOnly}
            handleSortBy={handleSortBy}
            sortByOptions={sortByOptions}
          />
        </Flex>
      )} */}
    </Flex>
  )
}

export default FilterHeader
